import { createContext, useState, type Dispatch, type SetStateAction } from 'react';
import type { ReactNode } from 'react';

interface PBIRefreshContextProps {
  isRefreshing: boolean;
  setIsRefreshing: (value: boolean) => void;
  onRefresh: (() => Promise<void>) | null;
  setOnRefresh: Dispatch<SetStateAction<(() => Promise<void>) | null>>;
}

export const PBIRefreshContext = createContext<PBIRefreshContextProps>({
  isRefreshing: false,
  setIsRefreshing: () => undefined,
  onRefresh: null,
  setOnRefresh: () => undefined
});

const PBIRefreshProvider = ({ children }: { children: ReactNode }) => {
  const [onRefresh, setOnRefresh] = useState<(() => Promise<void>) | null>(null);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  const value = {
    onRefresh,
    setOnRefresh,
    isRefreshing,
    setIsRefreshing
  };

  return <PBIRefreshContext.Provider value={value}>{children}</PBIRefreshContext.Provider>;
};

export default PBIRefreshProvider;
